import { ActionTree } from "vuex";
import { handleCommonApiErrors } from "@/api/CommonApiErrorHandler";
import OrderingApi from "@/api/OrderingApi";
import {
  IDeliveryDateInformationRequest,
  IDeliveryDateInformationResponse,
  IRootState,
} from "@iloq/shared";

const orderingApi = new OrderingApi();

const actions: ActionTree<IRootState, IRootState> = {
  getDeliveryDateInformation(
    { state },
    deliveryDateInformationRequest: IDeliveryDateInformationRequest,
  ): Promise<IDeliveryDateInformationResponse | void> {
    return orderingApi
      .getDeliveryDateInformation(deliveryDateInformationRequest)
      .catch(handleCommonApiErrors);
  },
};

export const deliveryDateModule = {
  actions,
  state: {},
  namespaced: true,
};
